import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" tekrevol_dark_bg  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Services">
                            <h2>Our .NET Development Services Provide You The Chance To Acquire Experience Top-Class Technology Solutions</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>ASP.NET is used to develop custom Windows applications that can function on multiple devices. TekRevol has years of experience in developing custom .NET development services for businesses worldwide. Our Dotnet development services provide all the features and functionalities necessary for modern businesses to stay in competition and progress towards a better future.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;